module.exports = __webpack_public_path__ + "895771d1252fe2f3f1945fc998ae3251.svg";